module.exports = __webpack_public_path__ + "static/media/Apple iPhone XS Silver.f8bf5829.png";